
import React, { useState, useEffect } from "react";
import "./ModalPagos.css";
import { authFetch } from "../utils/authFetch";

export default function ModalPagos({ cliente, onClose }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [pagos, setPagos] = useState([]);

  // Si no hay cliente, NO renderizamos el modal (pero después de hooks)
  const sinCliente = !cliente;

  // Cargar pagos desde backend
  useEffect(() => {
    if (!cliente) return;

    authFetch(`/api/pagos/cliente/${cliente.id}/${year}`)
      .then(res => res.json())
      .then(data => {
        if (data.ok && Array.isArray(data.pagos)) {
           setPagos(data.pagos);
         } else {
           setPagos([]);
        }
       })
      .catch(() => setPagos([]));
  }, [cliente, year]);   // 👈 ahora recarga pagos al cambiar el año
  if (sinCliente) return null;   // << ya no rompe hooks

  const meses = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  const nombreCompleto = `${cliente.nombre || ""} ${cliente.apellidos || ""}`.trim();

  function estaPagado(mes) {
    return pagos.some(p => p.mes === mes && p.anio === year);
  }

  return (
    <div className="mp-overlay">
      <div className="mp-card">
        
        {/* HEADER */}
        <div className="mp-header">
          <h3>Pagos de {nombreCompleto}</h3>
          <button className="mp-close" onClick={onClose}>×</button>
        </div>

        {/* SELECTOR AÑO */}
        <div className="mp-year-select">
          <button onClick={() => setYear(year-1)}>◀</button>
          <span>{year}</span>
          <button onClick={() => setYear(year+1)}>▶</button>
        </div>

        {/* FILA HORIZONTAL */}
        <div className="mp-grid-wrapper">
          <div className="mp-grid">
            {meses.map((m,i)=>{
              const pagado = estaPagado(i+1);
              return(
                <div key={i} className={`mp-mes ${pagado ? "pagado":"nopago"}`}>
                  <span className="mp-mes-label">{m}</span>
                  <div className="mp-status">{pagado ? "✔":"×"}</div>
                </div>
              )
            })}
          </div>
        </div>

      </div>
    </div>
  );
}

